import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Rx';
import { SidebarService } from '../../services/sidebar.service';
import { slideSidebar } from '../../animations/sidebar.animations';
import { handleOverlay } from '../../animations/overlay.animations';
import { routerTransition } from '../../animations/router.animations';
import { environment } from '@environments/environment';

@Component({
	selector: 'app-portal',
	animations: [routerTransition, slideSidebar, handleOverlay],
	templateUrl: './portal.component.html',
	styleUrls: ['./portal.component.scss']
})

/**
 * (c) it.x informationssysteme gmbh, Alle Rechte vorbehalten.
 *
 * Portal Component.
 */
export class PortalComponent implements OnDestroy
{
	/**
	 * Environment.
	 */
	public environment = environment;

	/**
	 * Subscripton for the sidebar service.
	 */
	private sidebarSubscription: Subscription;

	/**
	 * State: Is the sidebar open?.
	 */
	public sidebarIsOpened = false;

	/**
	 * Constructor.
	 */
	public constructor(
		private sidebarService: SidebarService
	)
	{
		this.sidebarSubscription = this.sidebarService.sidebarIsOpened.subscribe(
			(status) => this.sidebarIsOpened = status
		);
	}

	/**
	 * Lifecycle-Hook: OnDestroy.
	 */
	public ngOnDestroy()
	{
		this.sidebarSubscription.unsubscribe();
	}

	/**
	 * Returns the state of the router outlet.
	 */
	public getState(outlet)
	{
		return {
			value: outlet.activatedRouteData.state
		};
	}
}



// WEBPACK FOOTER //
// /var/data/workspace/hess/hess_smart_city_web/src/app/components/portal/portal.component.ts